import React from 'react';
import {connect} from 'react-redux'
import swal from 'sweetalert'
import UserRowEdit from './UserRowEdit'
import UserRowPasswordChange from './UserRowPasswordChange'

import {
  lock_user,
  unlock_user,
  destroy_user,
  reset_user_errors
} from '../actions'

const mapDispatchToProps = dispatch => {
  return {
    lockUser: (user_id) => dispatch( lock_user(user_id) ),
    unlockUser: (user_id) => dispatch( unlock_user(user_id) ),
    destroyUser: (user_id, page) => dispatch( destroy_user(user_id, page) ),
    resetErrors: () => dispatch( reset_user_errors() )
  }
}

class ConnectedUserRow extends React.Component {

  initEdit() {
    const {id} = this.props.user
    this.props.resetErrors()
    this.props.initEdit(id)
  }

  initChangePassword() {
    const {id} = this.props.user
    this.props.resetErrors()
    this.props.initChangePassword(id)
  }

  cancel() {
    this.props.initEdit(null)
  }

  lockUser() {
    const {user, lockUser} = this.props
    const {id} = user
    lockUser(id)
  }

  unlockUser() {
    const {user, unlockUser} = this.props
    const {id} = user
    unlockUser(id)
  }

  destroyUser() {
    const {user, destroyUser, page} = this.props
    const {id} = user
    destroyUser(id, page)
  }

  render() {
    const {user, current_user, currentEdit, currentChangePassword} = this.props
    const {id, name, email, locked, active, role, account} = user;

    let lockIcon, activeIcon, iconTitle

    if (active && !locked) {
      iconTitle = 'User is active'
      activeIcon = <i className="material-icons c-light-green">power</i>
      lockIcon = ''
    } else if ( active && locked ) {
      iconTitle = 'User is locked due to failed logins'
      activeIcon = <i className="material-icons c-yellow mr-10">power</i>
      lockIcon = <i className="material-icons c-red">lock</i>
    } else if (!active) {
      iconTitle = 'User is administravely disabled'
      activeIcon = <i className="material-icons c-red">power_off</i>
      lockIcon = ''
    }

    let roleIcon, roleTitle

    if (role === "admin") {
      roleTitle = 'Global Administrator'
      roleIcon = <i className="material-icons tiny c-red mr-10">build</i>
    } else if (role === "manager") {
      roleTitle = 'Account Manager'
      roleIcon = <i className="material-icons tiny c-yellow mr-10">work</i>
    } else {
      roleTitle = 'Account User'
      roleIcon = <i className="material-icons tiny c-light-green mr-10">perm_identity</i>
    }

    const pwdLink = ((current_user.role === "admin") || ((current_user.role === "manager") && (role !== "admin"))) ? (
        <a href="" className="action-btn" title="Change Password" onClick={ e=> {
          e.preventDefault()
          this.initChangePassword()
        }} ><i className="material-icons tiny c-darkgrey">vpn_key</i></a>
      ) : ""

    const editLink = (current_user.role === "manager" && role ==="admin") ? '' : (
      <a href="" className="action-btn" title="Edit" onClick={ e=> {
        e.preventDefault()
        this.initEdit()
      }}><i className="material-icons tiny c-light-green">create</i></a>
    )

    const unlockLink = (!locked) ? '' : (
      <a href="" className="action-btn" title="Unlock" onClick={ e=> {
        e.preventDefault()
        this.unlockUser()
      }}><i className="material-icons tiny c-light-green">lock_open</i></a>
    )

    const enableLink = (active) ? "" : (
      <a href="" className="action-btn" title="Enable" onClick={ e=> {
        e.preventDefault()
        this.unlockUser()
      }}><i className="material-icons tiny c-light-green">power</i></a>
    )

    const disableLink = (!active || current_user.id === id || (current_user.role === "manager" && role === "admin")) ? "" : (
      <a href="" className="action-btn" title="Disable" onClick={ e=> {
        e.preventDefault()
        this.lockUser()
      }}><i className="material-icons tiny c-yellow">power_off</i></a>
    )

    const delLink = (current_user.id === id || (current_user.role === "manager" && role === "admin")) ? '' : (
      <a href="" className="action-btn" title="Delete" onClick={ e=> {
        e.preventDefault()
        // this.destroyUser()
        swal({
          title: "Delete user?",
          text: `Are you sure that you want to delete user ${user.name}?`,
          icon: "error",
          buttons: [true, true ],
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            this.destroyUser()
          }
        });
      }}><i className="material-icons tiny c-red">delete_forever</i></a>
    )

    const showRow = (currentEdit !== id && currentChangePassword !== id) ? "" : "hide"
    const disabledClass = ( active ) ? "" : "accountDisabled"
    const showForm = (currentEdit === id) ? "" : "hide"
    const showPass = (currentChangePassword === id) ? "" : "hide"

    return (
      <React.Fragment>
        <tr className={`${showRow} ${disabledClass}`.trim()}>
          <td title={roleTitle}>
            { roleIcon } { name }
          </td>
          <td>
            <a href={`mailto:${email}?Subject=SFM Admin Message`} target="_top" className="mailColumn" title={`Send email to ${name}`}>
              <i className="material-icons tiny mr-10">mail_outline</i>{ email }
            </a>
          </td>
          <td>{ account.name }</td>
          <td title={iconTitle} className="userStatus">
            { activeIcon }
            { lockIcon }
          </td>
          <td>
            { pwdLink }
            { editLink }
            { unlockLink }
            { enableLink }
            { disableLink }
            { delLink }
          </td>
        </tr>

        <UserRowEdit user={user} current_user={current_user} showForm={showForm} cancel={this.cancel.bind(this)}/>

        <UserRowPasswordChange user={user} current_user={current_user} showPass={showPass} cancel={this.cancel.bind(this)}/>

      </React.Fragment>
    )

  }
}

const UserRow = connect(null, mapDispatchToProps)(ConnectedUserRow)
export default UserRow



// WEBPACK FOOTER //
// ./src/js/components/UserRow.js